import { render } from "./EditObjective.vue?vue&type=template&id=3f779fa5&scoped=true"
import script from "./EditObjective.vue?vue&type=script&lang=js"
export * from "./EditObjective.vue?vue&type=script&lang=js"

import "./EditObjective.vue?vue&type=style&index=0&id=3f779fa5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f779fa5"]])

export default __exports__